import { CHECK_RETURNS_TO_TEST, RETURN_TEST_REPORTED_SUCCESSFULLY, SIGN_IN } from "../actions/types";

const initialState = null;


//Here null means that I haven't checked if there are returns to test, if the value is an empty array then I've already checked but
//  there weren't any tests needed
export const returnsToTestReducer = (state = initialState, { type, payload }) => {
    switch (type) {


        case SIGN_IN:
            return initialState;

        case CHECK_RETURNS_TO_TEST:
            return [...payload.returnsToTest];

        case RETURN_TEST_REPORTED_SUCCESSFULLY:
            return state.splice(1);

        default:
            return state
    }
}


export default returnsToTestReducer;